import { createSelector } from 'reselect';
import { get } from 'stash/utils';
import { baseSelector } from './entities';

export const billingFrequenciesSelector = createSelector(baseSelector, (state) =>
	get(state, 'billing_frequencies', {})
);
